export enum SLStatusCode {
  Draft = 1,
  SentToPoster = 2,
  DraftClarificationNeeded = 3,
  Submitted = 4,
  Posted = 5,
  FailedInSAP = 6,
  SignoffNotRequired = 7,
  DocRequired = 8,
  SignoffInitiationRequired = 9,
  SignOffPending = 10,
  AwaitingClarification = 11,
  SignedOff = 12,
  DraftRecalled = 13,
  Validated = 14,
  Completed = 15
}

export const StatusCodesToString = {
  1: "Draft",
  2: "Sent To Poster",
  3: "Draft Clarification Needed",
  4: "Submitted",
  5: "Posted",
  6: "Failed In SAP",
  7: "Signoff Not Required",
  8: "Doc Required",
  9: "Signoff Initiation Required",
  10: "Sign Off Pending",
  11: "Awaiting Clarification",
  12: "Signed Off",
  13: "Draft Recalled",
  14: "Validated",
  15: "Completed"
};

export interface ISLStatusCodes {
  Draft: 1;
  SentToPoster: 2;
  DraftClarificationNeeded: 3;
  Submitted: 4;
  Posted: 5;
  FailedInSAP: 6;
  SignoffNotRequired: 7;
  DocRequired: 8;
  SignoffInitiationRequired: 9;
  SignOffPending: 10;
  AwaitingClarification: 11;
  SignedOff: 12;
  DraftRecalled: 13;
  Validated: 14;
  Completed: 15;
}
